module.exports = __webpack_public_path__ + "assets/img/icon1-menu2.9fb4aaf1.svg";